import React from 'react';
import { styled } from '@this/constants/themes';

interface Props {
  isActive: boolean;
  isBallon: boolean;
}

const DashboardButton: React.SFC<Props> = ({ isActive, isBallon, children }) => (
  <Balloon isActive={isActive} isBallon={isBallon}>
    {children}
  </Balloon>
);

const Balloon = styled.div<{ isActive: boolean; isBallon: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 249px;
  height: 64px;
  background-color: ${props => (props.isActive ? props.theme.accentColor : '#f7f7f7')};
  color: ${props => (props.isActive ? '#fff' : props.theme.accentColor)};
  ${props =>
    props.isBallon &&
    `
    &:before {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -15px;
      border: 15px solid transparent;
      border-top: 15px solid ${props.isActive ? props.theme.accentColor : '#f7f7f7'};
    }
  `}
`;

export default DashboardButton;
